import { render, staticRenderFns } from "./InfoWrapper.vue?vue&type=template&id=0ca7a6e0&scoped=true&lang=pug&"
import script from "./InfoWrapper.vue?vue&type=script&lang=js&"
export * from "./InfoWrapper.vue?vue&type=script&lang=js&"
import style0 from "./InfoWrapper.vue?vue&type=style&index=0&id=0ca7a6e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca7a6e0",
  null
  
)

export default component.exports